import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../../utils/overrides';
import Label from '../../Label';
import FieldBottom from '../FieldBottom';
import { createUseStyles } from '../../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'InputWrapper');
const InputWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    label,
    labelMode,
    isFullWidth,
    placeholder,
    hint,
    error,
    info,
    isRequired,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  const override = getOverrides(overridesProp, InputWrapper.overrides);
  const rootClassName = classnames(classes.root, {
    [classes[labelMode]]: labelMode,
    [classes.isFullWidth]: isFullWidth,
    [classes.error]: error
  }, classNameProp);
  const fieldBottomClass = classnames({
    [classes.fieldBottom]: label && labelMode === 'horizontal'
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName
  }, override.root), /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, label && /*#__PURE__*/React.createElement(Label, _extends({
    className: classes.Label,
    isRequired: isRequired,
    hint: hint
  }, override.Label), label), /*#__PURE__*/React.createElement("div", _extends({
    className: classes.formControl
  }, override.formControl, {
    ref: ref
  }), children)), /*#__PURE__*/React.createElement(FieldBottom, {
    className: fieldBottomClass,
    info: info,
    error: error,
    overrides: overridesProp,
    isFullWidth: isFullWidth
  }));
});
InputWrapper.overrides = ['root', 'error', 'info', 'formControl', 'Label', 'inputWrapper'];
InputWrapper.defaultProps = {
  labelMode: 'vertical',
  overrides: {}
};
process.env.NODE_ENV !== "production" ? InputWrapper.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  label: PropTypes.string,
  labelMode: PropTypes.oneOf(['horizontal', 'vertical']),
  isFullWidth: PropTypes.bool,
  /** Info popover */
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Error will be displayed below the component with style changes */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Info will be displayed below the component with style changes */
  info: PropTypes.string,
  isRequired: PropTypes.bool
} : void 0;
export default InputWrapper;